export const INSTRUCTION_VIEWED_KEY = "company-instruction-viewed";